import React from 'react';
import { BlacklistedRed } from '@saleshandy/icons';

const BlacklistedRedIcon = () => (
  <BlacklistedRed width={16} height={16} />
);

export default BlacklistedRedIcon;
